<script setup lang="ts">
import { getLists } from '~~/src/api/lists'
const props = defineProps<{
  search: string
}>()

const search = toRef(props, 'search')
const enterprise = useEnterprise()

const { data, pending, refresh } = useAPI(async () => {
  if (search.value.trim() === '')
    return []
  const data = await getLists({
    search: search.value,
    order_by: 'saves',
    size: 10,
  })

  return data
}, {
  watch: [search],
  immediate: false,
})
watch(enterprise, () => search.value !== '' && refresh())
watch(search, () => refresh())
const filteredLists = computed(() => {
  return (data.value)
    ? data.value
    : []
})
</script>

<template>
  <AppTab name="Lists" :count="filteredLists.length" overflow-auto>
    <List :lists="filteredLists" variant="search-item" :loading="pending" :is-searching="!!search" />
  </AppTab>
</template>
